import { commonRequest } from '@/utils/request'

const actions = {
  save: ({ commit }, data) => commonRequest({ data, url: '/apply/save' }),
  list: ({ commit }, data) => commonRequest({ data, url: '/apply/list' }),
  remove: ({ commit }, data) => commonRequest({ data, url: '/apply/remove' }),
  photo: ({ commit }, data) => commonRequest({ data, url: '/apply/photo' }),
}

export default {
  namespaced: true,
  actions,
}
